import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import CustomApprovalModal from "@/shared/components/custom-modal";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  // 재생성할 상품 수 — 안내 문구와 확인 버튼 라벨에 함께 들어간다.
  count: number;
  isLoading: boolean;
  onConfirm: () => void;
}

// 선택 상품 재생성 확인 — 단건(관리 열 버튼)과 일괄(선택 바 버튼)이 같은 모달을 쓴다.
// 실제 mutation은 부모(상품별 처리 내역 모달)가 소유한다.
function PathPickRetryConfirmModal({
  isOpen,
  onClose,
  count,
  isLoading,
  onConfirm,
}: Props) {
  const { t } = useI18nHelper();

  return (
    <CustomApprovalModal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      // 래퍼 기본값(480px)이 좁은 화면을 넘기지 않게 클램프한다.
      minWidth={"min(480px, 90dvw)"}
    >
      <CustomApprovalModal.Header
        title={t("path_pick:sync_download_history.retry_confirm.title")}
        onClose={onClose}
      />
      <CustomApprovalModal.Body>
        <Flex flexDirection={"column"} gap={"8px"}>
          <Text textStyle={"body-md-bold"} color={"#1D1D1B"}>
            {t("path_pick:sync_download_history.retry_confirm.body", { count })}
          </Text>
          <Text textStyle={"body-sm-medium"} color={"#444440"}>
            {t("path_pick:sync_download_history.retry_confirm.description")}
          </Text>
        </Flex>
      </CustomApprovalModal.Body>
      <CustomApprovalModal.Footer
        confirmName={t(
          "path_pick:sync_download_history.retry_confirm.confirm",
          {
            count,
          }
        )}
        onCancel={onClose}
        onConfirm={onConfirm}
        isLoading={isLoading}
      />
    </CustomApprovalModal>
  );
}

export default PathPickRetryConfirmModal;
